module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M29.8 2H26V1c0-.552-.648-1-1.2-1h-2c-.554 0-.8.448-.8 1v1h-4V1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1h-4V1c0-.552-.246-1-.8-1h-2C6.648 0 6 .448 6 1v1H2.2C1.096 2 0 2.894 0 4v26c0 1.106 1.096 2 2.2 2h27.6c1.104 0 2.2-.894 2.2-2V4c0-1.106-1.096-2-2.2-2zM10 28H6v-4h4v4zm0-8H6v-4h4v4zm8 8h-4v-4h4v4zm0-8h-4v-4h4v4zm8 8h-4v-4h4v4zm0-8h-4v-4h4v4zm2-8H4V6h2v1c0 .552.648 1 1.2 1h2c.554 0 .8-.448.8-1V6h4v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6h4v1c0 .552.246 1 .8 1h2c.552 0 1.2-.448 1.2-1V6h2v6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/calendar-5.js
// module id = 1037
// module chunks = 14